export function StandardFilePreview({url,contentType,title}:{url:string;contentType:string;title:string}){
 return contentType.startsWith("image/")?<div className="standard-file-preview"><img src={url} alt={title}/></div>:<iframe className="standard-file-preview-frame" title={title} src={url}/>;
}
